import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HttpClientModule } from '@angular/common/http';
import { ActivateMemberRoutingModule } from './activate-member-routing.module';
import { ActivateMemberComponent } from './activate-member.component';

@NgModule({
  imports: [CommonModule, IonicModule, ActivateMemberRoutingModule, HttpClientModule],
  declarations: [ActivateMemberComponent]
})
export class ActivateMemberModule {}
